// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import {application} from "./application"

// Datetime
import DatetimeController from "./datetime_controller"

application.register("datetime", DatetimeController)

// Removal
import RemovalsController from "./removals_controller"

application.register("removals", RemovalsController)

// Theme
import ThemeController from "./theme_controller"

application.register("theme", ThemeController)

// Character Counter
import CharacterCounter from '@stimulus-components/character-counter'

application.register('character-counter', CharacterCounter)

// Scroll To
import ScrollTo from '@stimulus-components/scroll-to'

application.register('scroll-to', ScrollTo)

import ScrollToController from "./scroll_to_controller"

application.register("scroll-to", ScrollToController)

// Scroll Progress
import ScrollProgress from '@stimulus-components/scroll-progress'

application.register('scroll-progress', ScrollProgress)

// Syntax Highlight
import SyntaxHighlightController from "./syntax_highlight_controller"

application.register("syntax-highlight", SyntaxHighlightController)

// Embla Carousel
import EmblaCarouselController from "./embla_carousel_controller"

application.register("embla-carousel", EmblaCarouselController)

// Modal Controller
import ModalController from "./modal_controller"

application.register("modal", ModalController)
